import React, { useEffect, useState, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import ReactECharts from 'echarts-for-react';
import usePrevious from '../../hooks/usePrevious';

const ReadTimeCategoryChart = ({ a, b, aColour, bColour, chartHeight = 300 }) => {
    const ref = useRef(null);
    const theme = useTheme();
    const [series, setSeries] = useState(null);
    const prevSeries = usePrevious(series);

    const options = {
        grid: {
            containLabel: true,
            left: theme.spacing(2),
            top: theme.spacing(4),
            right: 0,
            bottom: 0
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: params => `<b>${params[0].marker} ${params[0].name}</b></br>${new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 }).format(params[0].value[1])} instances`
        },
        yAxis: {
            name: 'Instances',
            nameGap: 15,
            nameTextStyle: {
                align: 'left'
            },
            axisLine: {
                show: true
            },
            minInterval: 1,
            axisLabel: {
                formatter: value => new Intl.NumberFormat('en-GB', { notation: 'compact' }).format(value)
            }
        },
        xAxis: {
            type: 'category'
        },
        series
    };

    useEffect(() => {
        let series = [
            {
                type: 'bar',
                name: b ? 'Period A' : '',
                data: a,
                color: aColour
            }
        ];

        if (b) {
            const bData = {
                type: 'bar',
                name: 'Period B',
                data: b,
                color: bColour
            };

            series.push(bData);
        }

        setSeries(series);
    }, [a, b]);

    useEffect(() => {
        // replaceMerge param is necessary to remove the 2nd dataset

        if (ref?.current && series && (series.length < prevSeries?.length)) {
            ref.current?.getEchartsInstance().setOption(options, { replaceMerge: ['series'] });
        }
    }, [series]);

    return (
        <ReactECharts
            option={options}
            style={{ height: chartHeight }}
            opts={{ renderer: 'svg' }}
            ref={ref}
        />
    );
};

export default ReadTimeCategoryChart;
